import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { useEffect, useState } from "react";
import { Loader } from "~/Components";
import { corporateHost } from "~/Utils";
import { fields, fieldsReady } from "../constants";
import { Language, useReports } from "../Sustainability.hook";
import { toUniqueKey } from "../Community/MainContent/MainContent";
export const Features: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: profileData, isLoading: isLoadingProfile, refetch: refetchOurProfile } = useReports();
  const { data: profileDataById, isLoading: isLoadingprofileById, refetch: refetchOurProfileById } = useDocumentDetails(query?.get("id") || "");

  console.log("profileDataById",profileDataById, profileData, fieldData, approveId);
  
  useEffect(() => {
    if (query?.get("id")) {
      const rawData = profileDataById?.payload;
      if (rawData) {
        setPayloadData({
          ...rawData,
          field_content_english: rawData.field_content_english 
            ? JSON.parse(rawData.field_content_english) 
            : null,
          field_content_malay: rawData.field_content_malay 
            ? JSON.parse(rawData.field_content_malay) 
            : null,
          field_content_mandarin: rawData.field_content_mandarin 
            ? JSON.parse(rawData.field_content_mandarin) 
            : null,
        });
      }
    } else {
      setPayloadData(profileData?.[0]);
    }
  }, [profileData, profileDataById, query]); 

  console.log("payloadData",payloadData);

  useEffect(()=>{
    if(approveId){
      refetchOurProfileById();
    }
    else{
      refetchOurProfile();
    }
  },[query.get('thirdChildActiveTab'), approveId])

  async function fetchData() {
    await fieldsReady;
    console.log("fieldsReadyfornow", fields); 
    setFieldData(fields);
  }

  useEffect(()=>{
    fetchData();
  },[])
  const createFormConfig = (name?: string, idx1?: any, field?: any): FormConfig => {
    const getTitleValue = (language: Language) => {
        const payload = profileDataById?.payload?.[language];
  
        if (!isLoadingprofileById) {
          if (typeof payload === "string") {
            try {
              return decodeHTML(JSON.parse(payload)?.data?.cardData?.[idx1]?.title);
            } catch (error) {
              return "";
            }
          } else if (typeof payload === "object") {
            return decodeHTML(payload?.data?.cardData?.[idx1]?.title);
          }
        }
  
        return decodeHTML(profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.title);
    };
    const getLinkValue = (language: Language) => {
      const payload = profileDataById?.payload?.[language];
    
      if (!isLoadingprofileById) {
        if (typeof payload === "string") {
          try {
            const link = JSON.parse(payload)?.data?.cardData?.[idx1]?.link;
            return formatLink(link);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          const link = payload?.data?.cardData?.[idx1]?.link;
          return formatLink(link);
        }
      }
    
      const link = profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.link;
      return formatLink(link);
    };    
    const formatLink = (link: any) => {
      if (typeof link === "string" && link.startsWith("https://")) {
        return decodeHTML([
          {
            uid: "-1",
            name: "link.pdf",
            status: "done",
            url: link,
          },
        ]);
      }
      return ""; // Return empty if the link is not a valid string
    };
    
    
    const getImageValue = (language: Language) => {
    const payload = profileDataById?.payload?.[language];

    if (!isLoadingprofileById) {
        if (typeof payload === "string") {
        try {
            return decodeHTML([
              {
                uid: "-1",
                name: "image.png",
                status: "done",
                url: JSON.parse(payload)?.data?.cardData?.[idx1]?.image,
              },
            ]);
        } catch (error) {
            return "";
        }
        } else if (typeof payload === "object") {
        return decodeHTML([
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: payload?.data?.cardData?.[idx1]?.image,
          },
        ]);
        }
    }

    return decodeHTML([
      {
        uid: "-1",
        name: "image.png",
        status: "done",
        url: profileData?.[0]?.[language]?.data?.cardData?.[idx1]?.image,
      },
    ]);
    };

    return {
      initialValues: {
        [`field_content_english.data.cardData[${idx1}].image`]: getImageValue("field_content_english"),
        [`field_content_english.data.cardData[${idx1}].title`]: getTitleValue("field_content_english"),
        [`field_content_english.data.cardData[${idx1}].link`]: getLinkValue("field_content_english"),
        [`field_content_malay.data.cardData[${idx1}].image`]: getImageValue("field_content_malay"),
        [`field_content_malay.data.cardData[${idx1}].title`]: getTitleValue("field_content_malay"),
        [`field_content_malay.data.cardData[${idx1}].link`]: getLinkValue("field_content_malay"),
        [`field_content_mandarin.data.cardData[${idx1}].image`]: getImageValue("field_content_mandarin"),
        [`field_content_mandarin.data.cardData[${idx1}].title`]: getTitleValue("field_content_mandarin"),
        [`field_content_mandarin.data.cardData[${idx1}].link`]: getLinkValue("field_content_mandarin"),
      },
      fields: field,
    };
  };

  const updatePayload = (data: any) => {
    console.log("updatePayloaddddd", data, payloadData);
    const convertDotNotation = (obj: any): any => {
        const result: any = {};
        for (const key in obj) {
            if (key.includes('.')) {
                const topLevelKey = key.split('.')[0];
                if (obj[topLevelKey] && typeof obj[topLevelKey] === 'object') {
                    continue;
                }
                
                const parts = key.split('.');
                let current = result;
                
                for (let i = 0; i < parts.length - 1; i++) {
                    current[parts[i]] = current[parts[i]] || {};
                    current = current[parts[i]];
                }
                
                current[parts[parts.length - 1]] = obj[key];
            } else {
                result[key] = obj[key];
            }
        }
        
        return result;
    };

    const filterNestedObjects = (obj: any): any => {
        const result: any = {};
        
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                if (Array.isArray(obj[key])) {
                    result[key] = obj[key];
                } else {
                    result[key] = filterNestedObjects(obj[key]);
                }
            } else {
                result[key] = obj[key];
            }
        }
        
        return result;
    };

    // const replacePayload = (target: any, source: any) => {
    //     // Get the cardData index being updated from the source data
    //     console.log("replacePayloda", target, source);
    //     const getUpdateIndex = (obj: any) => {
    //         const cardDataKey = Object.keys(obj).find(key => 
    //             key.includes('cardData') && typeof obj[key] === 'object'
    //         );
    //         if (cardDataKey) {
    //             const indexMatch = Object.keys(obj[cardDataKey])[0]?.match(/\[(\d+)\]/);
    //             return indexMatch ? parseInt(indexMatch[1]) : null;
    //         }
    //         return null;
    //     };

    //     for (const key in source) {
    //         // Handle cardData array specially
    //         if (key === 'data' && source[key]?.cardData) {
    //             const updateIndex = getUpdateIndex(data);
    //             if (updateIndex !== null && target[key]?.cardData) {
    //                 // Preserve existing cardData array
    //                 const updatedCardData = [...target[key].cardData];
                    
    //                 // Update only the specific index
    //                 if (source[key].cardData[updateIndex]) {
    //                     updatedCardData[updateIndex] = {
    //                         ...updatedCardData[updateIndex],
    //                         ...source[key].cardData[updateIndex]
    //                     };
                        
    //                     // Handle image and link fields specially
    //                     if (source[key].cardData[updateIndex].image) {
    //                         updatedCardData[updateIndex].image = 
    //                             source[key].cardData[updateIndex].image[0]?.url || 
    //                             source[key].cardData[updateIndex].image;
    //                     }
    //                     if (source[key].cardData[updateIndex].link) {
    //                         updatedCardData[updateIndex].link = 
    //                             source[key].cardData[updateIndex].link[0]?.url || 
    //                             source[key].cardData[updateIndex].link;
    //                     }
    //                 }
                    
    //                 target[key].cardData = updatedCardData;
    //                 continue;
    //             }
    //         }

    //         // Handle image and link fields
    //         if (key === "image" || key === 'link') {
    //             if (Array.isArray(source[key])) {
    //                 target[key] = source[key][0]?.originFileObj ? 
    //                     source[key] : 
    //                     (source[key][0]?.url || target[key]);
    //             } else if (typeof source[key] === "object" && source[key] !== null) {
    //                 target[key] = source[key].url || target[key];
    //             }
    //             continue;
    //         }

    //         // Handle nested objects
    //         if (typeof source[key] === "object" && source[key] !== null && !Array.isArray(source[key])) {
    //             target[key] = target[key] || {};
    //             replacePayload(target[key], source[key]);
    //         } else if (source[key] !== undefined) {
    //             target[key] = source[key];
    //         }
    //     }
    // };

    const mergeCardDataItem = (newItem: any, existingItem: any): any => {
      // If newItem is empty, return existingItem
      if (!newItem || Object.keys(newItem).length === 0) {
          return existingItem;
      }
  
      console.log("mergeCardDataItem", newItem, existingItem);
      
      // If existingItem is null, return newItem directly
      if (!existingItem) {
          return newItem;
      }
      
      // If existingItem exists, merge while preserving id
      return {
          ...existingItem,
          ...newItem,
          ...(existingItem.id && { id: existingItem.id })
      };
  };

  // Helper function to merge arrays while preserving existing items and ids
  const mergeArrays = (newArray: any[], existingArray: any[], path: string): any[] => {
      const result = [...existingArray];
      console.log("mergeArrays", newArray, existingArray, path);
      newArray.forEach((item, index) => {
        console.log("mergeArrays -2", item, index, existingArray);
          if (item && Object.keys(item).length > 0) {
              if (path.includes('cardData')) {
                  result[index] = mergeCardDataItem(item, existingArray[index]);
              } else {
                  result[index] = item;
              }
          }
      });
      
      return result;
  };

  // Helper function to deep merge objects
  const deepMerge = (target: any, source: any, path: string = ''): any => {
      const result = { ...target };
      
      for (const key in source) {
          const currentPath = path ? `${path}.${key}` : key;
          
          if (typeof source[key] === 'object' && source[key] !== null) {
              if (Array.isArray(source[key])) {
                  if (target[key] && Array.isArray(target[key])) {
                    console.log("deepmerge array if", target[key], source[key], key, target, source);
                      result[key] = mergeArrays(source[key], target[key], currentPath);
                  } else {
                    console.log("deepmerge array else", target[key], source[key], key, target, source);
                      result[key] = source[key];
                  }
              } else {
                console.log("deepmerge array object else", target[key], source[key], key, target, source);
                  result[key] = deepMerge(target[key] || {}, source[key], currentPath);
              }
          } else if (source[key] !== undefined) {
            console.log("deepmerge array final else if", target[key], source[key], key, target, source);
              result[key] = source[key];
          }
      }
      
      return result;
  };

    const convertedData = convertDotNotation(data);
    console.log("converereddata", convertedData, payloadData);
    const filteredData = filterNestedObjects(convertedData);
    console.log("fiteredDat", filteredData, payloadData);
    const payloads= payloadData;
    const parseIfString = (data: any) => {
      try {
        return typeof data === "string" ? JSON.parse(data) : data;
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return data;
      }
    };
    
    const parsedPayloadData = {
      ...payloadData,
      field_content_english: parseIfString(payloadData.field_content_english),
      field_content_malay: parseIfString(payloadData.field_content_malay),
      field_content_mandarin: parseIfString(payloadData.field_content_mandarin),
    };

    console.log("parsedPayloadData", parsedPayloadData);
    
    const updateValue = deepMerge(parsedPayloadData, filteredData);
    
    console.log("replacePyalodData", payloads, updateValue);
    return updateValue;
};

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
  const payloadDatas = await updatePayload(data);
  console.log("payloadatasssssssss", payloadDatas);
  let imageKeys = [];
  const featuresLength = payloadDatas.field_content_english?.data?.cardData?.length || 0;
  
  for (let i = 0; i < featuresLength; i++) {
    imageKeys.push(
      `field_content_mandarin.data.cardData.${i}.image`,
      `field_content_malay.data.cardData.${i}.image`,
      `field_content_english.data.cardData.${i}.image`,
      `field_content_mandarin.data.cardData.${i}.link`,
      `field_content_malay.data.cardData.${i}.link`,
      `field_content_english.data.cardData.${i}.link`
    );
  }
  
  for (const key of imageKeys) {
    try {
      let keysArray = key.split(".");
      let field = payloadDatas;
      let lastKey = keysArray.pop();
      for (const k of keysArray) {
        if (k.includes("[") && k.includes("]")) {
          const arrayKey = k.split("[")[0];
          const index = parseInt(k.match(/\d+/)?.[0] || "0", 10);
          field = field?.[arrayKey]?.[index] ?? undefined;
        } else {
          field = field?.[k] ?? undefined;
        }
      }
  
      if (field && lastKey && Array.isArray(field[lastKey]) && field[lastKey][0]) {
        if (field[lastKey][0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[lastKey][0].originFileObj);
          formData.append("application", "CORPORATE");
  
          const res: any = await post("management/upload-file", formData);
  
          if (res) {
            field[lastKey] = res.response.data; 
          }
        } else if (field[lastKey][0].url) {
          field[lastKey] = field[lastKey][0].url;
        }
      }
    } catch (error) {
      console.error("Error updating image field:", key, error);
    }
  }  
  console.log("payloadatasssssssss", payloadDatas);
  
      if (payloadDatas.field_content_english) {
        payloadDatas.field_content_english = JSON.stringify(payloadDatas.field_content_english);
  
  }
  if (payloadDatas.field_content_malay) {
    payloadDatas.field_content_malay = JSON.stringify(payloadDatas.field_content_malay);
  }
  if (payloadDatas.field_content_mandarin) {
    payloadDatas.field_content_mandarin = JSON.stringify(payloadDatas.field_content_mandarin);
  }
    let payload = {
        action: action,
        method: method,
        module: "Sustainability",
        subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get('thirdChildActiveTab')}`,
        type: "DEDICATED",
        application: "MAHB_CORPORATE",
        reviewNotes: reviewNotes,
        appList: [
          {
            appName: "MAHB_CORPORATE",
            apiUrl: apiUrl,
          },
        ],
        moduleKey: "MAHB_CORPORATE_Sustainability_Reports",
        // payload: {
        //   ...payloadDatas,
        //   field_content_malay: payloadDatas?.field_content_malay
        //     ? JSON.stringify(payloadDatas.field_content_malay)
        //     : payloadDatas.field_content_malay,
        //   field_content_english: payloadDatas?.field_content_english
        //     ? JSON.stringify(payloadDatas.field_content_english)
        //     : payloadDatas.field_content_english,
        //   field_content_mandarin: payloadDatas?.field_content_mandarin
        //     ? JSON.stringify(payloadDatas.field_content_mandarin)
        //     : payloadDatas.field_content_mandarin,
        // },
        payload: payloadDatas,
        status: status,
      };
      console.log("payloaddddddddd", payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => ({
    label,
    key,
    children: (
      <DynamicForm
        isLoading={isLoadingProfile || isLoadingprofileById}
        config={config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
        }
        defaultReviewNotes="Kindly review this Sustainability"
      />
    ),
  }); 

  const profileChildItems = profileData
  ? profileData?.[0]?.field_content_english?.data?.cardData
      .filter(Boolean)
      .map((item: any, index: any) => {
        console.log("indexitemfornow", item, index, fieldData);
        const uniqueKey = `${toUniqueKey(item.title)}ForReports_${index}`;
        return generateFormItem(
          item.title,
          uniqueKey,
          createFormConfig(item.title, [index], fieldData?.reportsFeatures?.[index]),
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || '100'}`
        );
      })
  : (() => {
      const fieldContent = profileDataById?.payload?.field_content_english;
      let parsedContent;
      // Validate and safely parse JSON
      if (typeof fieldContent === "string") {
        try {
          parsedContent = JSON.parse(fieldContent);
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }
      } else if (typeof fieldContent === "object" && fieldContent !== null) {
        parsedContent = fieldContent;
      } else {
        parsedContent = null;
      }
      console.log("parsedContent",parsedContent, fieldContent);
      return parsedContent?.data?.cardData
        ?.filter(Boolean)
        ?.map((item: any, index: any) => {
            const uniqueKey = `${toUniqueKey(item.title)}ForReports_${index}`;
          return generateFormItem(
            item?.title,
            uniqueKey,
            createFormConfig(item?.title, [index], fieldData?.reportsFeatures?.[index]),
            `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || '100'}`
          );
        }) || [];
    })();

  return (
    <>
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={profileChildItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
